import SafetyAnchorPointModelBase from '../_generated/modelBases/safety-anchor-point-model-base';

export default class SafetyAnchorPointModel extends SafetyAnchorPointModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
